export const DESCOPE_PROJECT_ID = 'P2s2TsaOffPNb7xnJXXBgTAH87LC';
export const DESCOPE_FLOW_IDS = {
  MAIN_SIGN_IN_SCREEN: 'sign-up-or-in-main',
  MEMBERS_INVITE_SCREEN: 'sign-up-or-in-members-invite',
};
export const AUTH_PROVIDERS = {
  DESCOPE: 'descope',
  FIREBASE: 'firebase',
} as const;
